// extracted by mini-css-extract-plugin
export default {"closeButton":"t7qH2","page":"XN4L9","title":"_2b9fq","description":"khVI9","loginButtonContainer":"_1_v_b"};